export default {
    "smartElectricity.smarElectricity.218347-0": "Settlement list",
    "smartElectricity.smarElectricity.218347-1": "Setting rate",
    "smartElectricity.smarElectricity.218347-2": "Authorized users",
    "smartElectricity.smarElectricity.218347-3": "User management",
    "smartElectricity.smarElectricity.218347-4": "Management",
    "smartElectricity.smarElectricity.218347-5": "Corporate governance",
    "smartElectricity.smarElectricity.218347-6": "Group management",
    "smartElectricity.smarElectricity.218347-7": "Merchant fees",
    "smartElectricity.smarElectricity.218347-8": "One-click import",
    "smartElectricity.smarElectricity.218347-9": "Warning",
    "smartElectricity.smarElectricity.218347-10": "Back",
    "smartElectricity.smarElectricity.218347-11": "Users",
    "smartElectricity.smarElectricity.218347-12": "",
    "smartElectricity.smarElectricity.218347-13": "Alarm device",
    "smartElectricity.smarElectricity.218347-14": "",
    "smartElectricity.smarElectricity.218347-15": "Online device",
    "smartElectricity.smarElectricity.218347-16": "Offline device",
    "smartElectricity.smarElectricity.218347-17": "View reports",
    "smartElectricity.smarElectricity.218347-18": "Alarms for devices",
    "smartElectricity.smarElectricity.218347-19": "",
    "smartElectricity.smarElectricity.218347-20": "Processed",
    "smartElectricity.smarElectricity.218347-21": "To be processed",
    "smartElectricity.smarElectricity.218347-22": "List of cities",
    "smartElectricity.smarElectricity.218347-23": "Refresh",
    "smartElectricity.smarElectricity.218347-24": "Search",
    "smartElectricity.smarElectricity.218347-25": "Please enter a name to search",
    "smartElectricity.smarElectricity.218347-26": "No data",
    "smartElectricity.smarElectricity.218347-27": "No region",
    "smartElectricity.smarElectricity.218347-28": "No city",
    "smartElectricity.smarElectricity.218347-29": "Report",
    "smartElectricity.smarElectricity.218347-30": "泰邦",
    "smartElectricity.smarElectricity.218347-31": "Area: Zhejiang Province - Taizhou City - Yuhuan County",
    "smartElectricity.smarElectricity.218347-32": "Please enter the name or device code to search",
    "smartElectricity.smarElectricity.218347-33": "Online",
    "smartElectricity.smarElectricity.218347-34": "Normal",
    "smartElectricity.smarElectricity.218347-35": "Upstairs workshop",
    "smartElectricity.smarElectricity.218347-36": "Device code: 10001010",
    "smartElectricity.smarElectricity.218347-37": "List of user devices",
    "smartElectricity.smarElectricity.218347-38": "Are you sure to delete this user?",
    "smartElectricity.smarElectricity.218347-39": "Delete the user",
    "smartElectricity.smarElectricity.218347-40": "Add Device",
    "smartElectricity.smarElectricity.218347-41": "Address",
    "smartElectricity.smarElectricity.218347-42": "Mobile",
    "smartElectricity.smarElectricity.218347-43": "Please enter device code to search",
    "smartElectricity.smarElectricity.218347-44": "No device",
    "smartElectricity.smarElectricity.218347-45": "Device Details",
    "smartElectricity.smarElectricity.218347-46": "Device Name:",
    "smartElectricity.smarElectricity.218347-47": "Device Code:",
    "smartElectricity.smarElectricity.218347-48": "Switch state:",
    "smartElectricity.smarElectricity.218347-49": "Close",
    "smartElectricity.smarElectricity.218347-50": "open",
    "smartElectricity.smarElectricity.218347-51": "Online Status:",
    "smartElectricity.smarElectricity.218347-52": "offline",
    "smartElectricity.smarElectricity.218347-53": "Device address:",
    "smartElectricity.smarElectricity.218347-54": "Contact number:",
    "smartElectricity.smarElectricity.218347-55": "Not set",
    "smartElectricity.smarElectricity.218347-56": "Are you sure you want to silence the device?" ,
    "smartElectricity.smarElectricity.218347-57": "silenced",
    "smartElectricity.smarElectricity.218347-58": "Interrogation",
    "smartElectricity.smarElectricity.218347-59": "Are you sure about the gate?" ,
    "smartElectricity.smarElectricity.218347-60": "Are you sure you close?" ,
    "smartElectricity.smarElectricity.218347-61": "Are you sure you want to close the valve?" ,
    "smartElectricity.smarElectricity.218347-62": "Closing the valve",
    "smartElectricity.smarElectricity.218347-63": "probe",
    "smartElectricity.smarElectricity.218347-64": "modified",
    "smartElectricity.smarElectricity.218347-65": "Unbind?" ,
    "smartElectricity.smarElectricity.218347-66": "Delete",
    "smartElectricity.smarElectricity.218347-67": "clock",
    "smartElectricity.smarElectricity.218347-68": "Password",
    "smartElectricity.smarElectricity.218347-69": "Data",
    "smartElectricity.smarElectricity.218347-70": "Monitoring",
    "smartElectricity.smarElectricity.218347-71": "Alarm",
    "smartElectricity.smarElectricity.218347-72": "Settings",
    "smartElectricity.smarElectricity.218347-73": "Function switch state:",
    "smartElectricity.smarElectricity.218347-74": "Battery type:",
    "smartElectricity.smarElectricity.218347-75": "Power status:",
    "smartElectricity.smarElectricity.218347-76": "Battery remaining charge:",
    "smartElectricity.smarElectricity.218347-77": "Monitoring status:",
    "smartElectricity.smarElectricity.218347-78": "Demolition:",
    "smartElectricity.smarElectricity.218347-79": "Humidity value:",
    "smartElectricity.smarElectricity.218347-80": "Temperature value:",
    "smartElectricity.smarElectricity.218347-81": "Power supply mode:",
    "smartElectricity.smarElectricity.218347-82": "Battery powered:",
    "smartElectricity.smarElectricity.218347-83": "Battery level:",
    "smartElectricity.smarElectricity.218347-84": "Battery voltage:",
    "smartElectricity.smarElectricity.218347-85": "Battery 100%:",
    "smartElectricity.smarElectricity.218347-86": "Communication time:",
    "smartElectricity.smarElectricity.218347-87": "Please select data for a certain day",
    "smartElectricity.smarElectricity.218347-88": "voltage",
    "smartElectricity.smarElectricity.218347-89": "current",
    "smartElectricity.smarElectricity.218347-90": "temperature",
    "smartElectricity.smarElectricity.218347-91": "Active Power",
    "smartElectricity.smarElectricity.218347-92": "Reactive power",
    "smartElectricity.smarElectricity.218347-93": "leakage",
    "smartElectricity.smarElectricity.218347-94": "Please handle",
    "smartElectricity.smarElectricity.218347-95": "Processing",
    "smartElectricity.smarElectricity.218347-96": "false positive",
    "smartElectricity.smarElectricity.218347-97": "No alarm information",
    "smartElectricity.smarElectricity.218347-98": "Overcurrent protection",
    "smartElectricity.smarElectricity.218347-99": "Overcurrent trip rating",
    "smartElectricity.smarElectricity.218347-100": "Overcurrent alarm rating",
    "smartElectricity.smarElectricity.218347-101": "Overcurrent trip delay",
    "smartElectricity.smarElectricity.218347-102": "Overcurrent alarm delay",
    "smartElectricity.smarElectricity.218347-103": "Overcurrent alarm surrender",
    "smartElectricity.smarElectricity.218347-104": "Exit",
    "smartElectricity.smarElectricity.218347-105": "Input",
    "smartElectricity.smarElectricity.218347-106": "Overcurrent trip surrender",
    "smartElectricity.smarElectricity.218347-107": "Overcurrent trip latching",
    "smartElectricity.smarElectricity.218347-108": "Overload protection",
    "smartElectricity.smarElectricity.218347-109": "Overload trip rating",
    "smartElectricity.smarElectricity.218347-110": "Overload alarm rating",
    "smartElectricity.smarElectricity.218347-111": "Overload trip delay",
    "smartElectricity.smarElectricity.218347-112": "Overload Alarm Delay",
    "smartElectricity.smarElectricity.218347-113": "overload alarm surrender",
    "smartElectricity.smarElectricity.218347-114": "overload trip surrender",
    "smartElectricity.smarElectricity.218347-115": "Overload trip latching",
    "smartElectricity.smarElectricity.218347-116": "Leakage protection",
    "smartElectricity.smarElectricity.218347-117": "Leakage trip rating",
    "smartElectricity.smarElectricity.218347-118": "Leakage alarm rating",
    "smartElectricity.smarElectricity.218347-119": "Leakage trip delay",
    "smartElectricity.smarElectricity.218347-120": "Leakage alarm delay",
    "smartElectricity.smarElectricity.218347-121": "Leakage alarm surrender",
    "smartElectricity.smarElectricity.218347-122": "leakage trip surrender",
    "smartElectricity.smarElectricity.218347-123": "Overvoltage protection",
    "smartElectricity.smarElectricity.218347-124": "Overvoltage trip rating",
    "smartElectricity.smarElectricity.218347-125": "Overvoltage alarm value",
    "smartElectricity.smarElectricity.218347-126": "Overvoltage trip delay",
    "smartElectricity.smarElectricity.218347-127": "Overvoltage Alarm Delay",
    "smartElectricity.smarElectricity.218347-128": "Overvoltage alarm surrender",
    "smartElectricity.smarElectricity.218347-129": "Overvoltage trip surrender",
    "smartElectricity.smarElectricity.218347-130": "Undervoltage protection",
    "smartElectricity.smarElectricity.218347-131": "Undervoltage trip rating",
    "smartElectricity.smarElectricity.218347-132": "Undervoltage alarm rating",
    "smartElectricity.smarElectricity.218347-133": "Undervoltage trip delay",
    "smartElectricity.smarElectricity.218347-134": "Undervoltage alarm delay",
    "smartElectricity.smarElectricity.218347-135": "Undervoltage alarm surrender",
    "smartElectricity.smarElectricity.218347-136": "Undervoltage trip surrender",
    "smartElectricity.smarElectricity.218347-137": "Over-undervoltage recovery",
    "smartElectricity.smarElectricity.218347-138": "Overvoltage Recovery Closing Rating",
    "smartElectricity.smarElectricity.218347-139": "Undervoltage recovery closing setting",
    "smartElectricity.smarElectricity.218347-140": "Overvoltage Recovery Closing Delay",
    "smartElectricity.smarElectricity.218347-141": "Undervoltage Recovery Closing Delay",
    "smartElectricity.smarElectricity.218347-142": "Overvoltage recovery closing surrender",
    "smartElectricity.smarElectricity.218347-143": "Undervoltage recovery closure surrender",
    "smartElectricity.smarElectricity.218347-144": "Arc protection",
    "smartElectricity.smarElectricity.218347-145": "Arc trip rating",
    "smartElectricity.smarElectricity.218347-146": "Arc alarm rating",
    "smartElectricity.smarElectricity.218347-147": "Arc trip delay",
    "smartElectricity.smarElectricity.218347-148": "Arc alarm delay",
    "smartElectricity.smarElectricity.218347-149": "arc alarm surrender",
    "smartElectricity.smarElectricity.218347-150": "Arc trip surrender",
    "smartElectricity.smarElectricity.218347-151": "Overtemperature protection",
    "smartElectricity.smarElectricity.218347-152": "Overtemperature trip value",
    "smartElectricity.smarElectricity.218347-153": "Overtemperature alarm value",
    "smartElectricity.smarElectricity.218347-154": "Overtemperature trip delay",
    "smartElectricity.smarElectricity.218347-155": "Overtemperature alarm delay",
    "smartElectricity.smarElectricity.218347-156": "Overtemperature alarm surrender",
    "smartElectricity.smarElectricity.218347-157": "Overtemperature trip surrender",
    "smartElectricity.smarElectricity.218347-158": "Phase Loss Protection",
    "smartElectricity.smarElectricity.218347-159": "Phase loss trip rating",
    "smartElectricity.smarElectricity.218347-160": "Phase Loss Alarm Rating",
    "smartElectricity.smarElectricity.218347-161": "Phase loss trip delay",
    "smartElectricity.smarElectricity.218347-162": "Missing phase alarm delay",
    "smartElectricity.smarElectricity.218347-163": "Absence of phase alarm surrender",
    "smartElectricity.smarElectricity.218347-164": "Phase loss trip surrender",
    "smartElectricity.smarElectricity.218347-165": "Continuous Action Latching",
    "smartElectricity.smarElectricity.218347-166": "Latching time",
    "smartElectricity.smarElectricity.218347-167": "Number of actions",
    "smartElectricity.smarElectricity.218347-168": "Three-phase overvoltage recovery",
    "smartElectricity.smarElectricity.218347-169": "Three-phase undervoltage recovery",
    "smartElectricity.smarElectricity.218347-170": "Over-undervoltage recovery time",
    "smartElectricity.smarElectricity.218347-171": "System Parameters",
    "smartElectricity.smarElectricity.218347-172": "Electricity storage interval",
    "smartElectricity.smarElectricity.218347-173": "Immediate storage threshold",
    "smartElectricity.smarElectricity.218347-174": "Interval storage threshold",
    "smartElectricity.smarElectricity.218347-175": "Electricity",
    "smartElectricity.smarElectricity.218347-176": "Maximum number of upgrade restarts",
    "smartElectricity.smarElectricity.218347-177": "Number of abnormal heartbeat restarts",
    "smartElectricity.smarElectricity.218347-178": "Commit Settings",
    "smartElectricity.smarElectricity.218347-179": "Summoning threshold",
    "smartElectricity.smarElectricity.218347-180": "Summoning threshold 1",
    "smartElectricity.smarElectricity.218347-181": "Summoning threshold 2",
    "smartElectricity.smarElectricity.218347-182": "Instant alert message",
    "smartElectricity.smarElectricity.218347-183": "Device Name",
    "smartElectricity.smarElectricity.218347-184": "Device Number",
    "smartElectricity.smarElectricity.218347-185": "User Name",
    "smartElectricity.smarElectricity.218347-186": "Full address",
    "smartElectricity.smarElectricity.218347-187": "Time",
    "smartElectricity.smarElectricity.218347-188": "type",
    "smartElectricity.smarElectricity.218347-189": "Operation",
    "smartElectricity.smarElectricity.218347-190": "No alarm messages",
    "smartElectricity.smarElectricity.218347-191": "more",
    "smartElectricity.smarElectricity.218347-192": "Add Region",
    "smartElectricity.smarElectricity.218347-193": "Area Name",
    "smartElectricity.smarElectricity.218347-194": "Please enter a name for the area",
    "smartElectricity.smarElectricity.218347-195": "Search Address",
    "smartElectricity.smarElectricity.218347-196": "longitude",
    "smartElectricity.smarElectricity.218347-197": "latitude",
    "smartElectricity.smarElectricity.218347-198": "Remarks",
    "smartElectricity.smarElectricity.218347-199": "Please enter a comment",
    "smartElectricity.smarElectricity.218347-200": "Next",
    "smartElectricity.smarElectricity.218347-201": "cancel",
    "smartElectricity.smarElectricity.218347-202": "User List",
    "smartElectricity.smarElectricity.218347-203": "Add User",
    "smartElectricity.smarElectricity.218347-204": "Login username",
    "smartElectricity.smarElectricity.218347-205": "Mobile Phone",
    "smartElectricity.smarElectricity.218347-206": "Email",
    "smartElectricity.smarElectricity.218347-207": "Contact Address",
    "smartElectricity.smarElectricity.218347-208": "Is it an administrator",
    "smartElectricity.smarElectricity.218347-209": "Yes",
    "smartElectricity.smarElectricity.218347-210": "No",
    "smartElectricity.smarElectricity.218347-211": "No users",
    "smartElectricity.smarElectricity.218347-212": "List of departments",
    "smartElectricity.smarElectricity.218347-213": "Add Department",
    "smartElectricity.smarElectricity.218347-214": "Department Number",
    "smartElectricity.smarElectricity.218347-215": "Department Name",
    "smartElectricity.smarElectricity.218347-216": "Created by",
    "smartElectricity.smarElectricity.218347-217": "Date Created",
    "smartElectricity.smarElectricity.218347-218": "permissions",
    "smartElectricity.smarElectricity.218347-219": "City",
    "smartElectricity.smarElectricity.218347-220": "No department",
    "smartElectricity.smarElectricity.218347-221": "Company List",
    "smartElectricity.smarElectricity.218347-222": "Add Company",
    "smartElectricity.smarElectricity.218347-223": "Company Number",
    "smartElectricity.smarElectricity.218347-224": "Company Name",
    "smartElectricity.smarElectricity.218347-225": "Contact number",
    "smartElectricity.smarElectricity.218347-226": "No Company",
    "smartElectricity.smarElectricity.218347-227": "Add merchant fee",
    "smartElectricity.smarElectricity.218347-228": "Purchase Type",
    "smartElectricity.smarElectricity.218347-229": "Price",
    "smartElectricity.smarElectricity.218347-230": "month",
    "smartElectricity.smarElectricity.218347-231": "Quarter",
    "smartElectricity.smarElectricity.218347-232": "Year",
    "smartElectricity.smarElectricity.218347-233": "yuan",
    "smartElectricity.smarElectricity.218347-234": "Add merchant fee template",
    "smartElectricity.smarElectricity.218347-235": "Purchase Category",
    "smartElectricity.smarElectricity.218347-236": "Please enter price",
    "smartElectricity.smarElectricity.218347-237": "submit",
    "smartElectricity.smarElectricity.218347-238": "Reset",
    "smartElectricity.smarElectricity.218347-239": "Modify merchant fee template",
    "smartElectricity.smarElectricity.218347-240": "Group List",
    "smartElectricity.smarElectricity.218347-241": "Add Group",
    "smartElectricity.smarElectricity.218347-242": "Group Number",
    "smartElectricity.smarElectricity.218347-243": "Group Name",
    "smartElectricity.smarElectricity.218347-244": "No Group",
    "smartElectricity.smarElectricity.218347-245": "Select Group",
    "smartElectricity.smarElectricity.218347-246": "Select Company",
    "smartElectricity.smarElectricity.218347-247": "Select Department",
    "smartElectricity.smarElectricity.218347-248": "Employee Number",
    "smartElectricity.smarElectricity.218347-249": "Please enter employee number",
    "smartElectricity.smarElectricity.218347-250": "Please enter login username",
    "smartElectricity.smarElectricity.218347-251": "User login password",
    "smartElectricity.smarElectricity.218347-252": "Please enter user login password",
    "smartElectricity.smarElectricity.218347-253": "Financial authority",
    "smartElectricity.smarElectricity.218347-254": "Identification Number",
    "smartElectricity.smarElectricity.218347-255": "Please enter your ID number",
    "smartElectricity.smarElectricity.218347-256": "Name",
    "smartElectricity.smarElectricity.218347-257": "Please enter a name",
    "smartElectricity.smarElectricity.218347-258": "Please enter a mobile phone",
    "smartElectricity.smarElectricity.218347-259": "Gender",
    "smartElectricity.smarElectricity.218347-260": "male",
    "smartElectricity.smarElectricity.218347-261": "Female",
    "smartElectricity.smarElectricity.218347-262": "Other",
    "smartElectricity.smarElectricity.218347-263": "Please enter email",
    "smartElectricity.smarElectricity.218347-264": "Please enter contact address",
    "smartElectricity.smarElectricity.218347-265": "Date of birth",
    "smartElectricity.smarElectricity.218347-266": "Please enter date of birth",
    "smartElectricity.smarElectricity.218347-267": "Educational Attainment",
    "smartElectricity.smarElectricity.218347-268": "Please enter education",
    "smartElectricity.smarElectricity.218347-269": "Please enter department number",
    "smartElectricity.smarElectricity.218347-270": "Please enter department name",
    "smartElectricity.smarElectricity.218347-271": "Company title",
    "smartElectricity.smarElectricity.218347-272": "Please enter company title",
    "smartElectricity.smarElectricity.218347-273": "Please enter company number",
    "smartElectricity.smarElectricity.218347-274": "Please enter company name",
    "smartElectricity.smarElectricity.218347-275": "Please enter contact number",
    "smartElectricity.smarElectricity.218347-276": "Bank",
    "smartElectricity.smarElectricity.218347-277": "Please enter the bank with which you are accounting",
    "smartElectricity.smarElectricity.218347-278": "Account Opening Card Number",
    "smartElectricity.smarElectricity.218347-279": "Please enter the opening card number",
    "smartElectricity.smarElectricity.218347-280": "Business License",
    "smartElectricity.smarElectricity.218347-281": "Please enter business license",
    "smartElectricity.smarElectricity.218347-282": "Please enter address",
    "smartElectricity.smarElectricity.218347-283": "Company Chinese name",
    "smartElectricity.smarElectricity.218347-284": "Please enter Chinese name",
    "smartElectricity.smarElectricity.218347-285": "Company name",
    "smartElectricity.smarElectricity.218347-286": "Please enter English name",
    "smartElectricity.smarElectricity.218347-287": "Company logo",
    "smartElectricity.smarElectricity.218347-288": "Please enter group number",
    "smartElectricity.smarElectricity.218347-289": "Please enter group name",
    "smartElectricity.smarElectricity.218347-290": "modify user",
    "smartElectricity.smarElectricity.218347-291": "Modification Department",
    "smartElectricity.smarElectricity.218347-292": "Modify Company",
    "smartElectricity.smarElectricity.218347-293": "Editorial Group",
    "smartElectricity.smarElectricity.218347-294": "Select City",
    "smartElectricity.smarElectricity.218347-295": "Assign permissions",
    "smartElectricity.smarElectricity.218347-296": "Device Add Permissions",
    "smartElectricity.smarElectricity.218347-297": "Micro-disconnect device operation button",
    "smartElectricity.smarElectricity.218347-298": "Smoke Sensing Device Operation Button",
    "smartElectricity.smarElectricity.218347-299": "Air sensing device operation button",
    "smartElectricity.smarElectricity.218347-300": "Permission Settings",
    "smartElectricity.smarElectricity.218347-301": "Owner's Phone",
    "smartElectricity.smarElectricity.218347-302": "Please enter the owner's phone",
    "smartElectricity.smarElectricity.218347-303": "Inquiry",
    "smartElectricity.smarElectricity.218347-304": "Building",
    "smartElectricity.smarElectricity.218347-305": "Please enter building",
    "smartElectricity.smarElectricity.218347-306": "Unit",
    "smartElectricity.smarElectricity.218347-307": "Please enter unit",
    "smartElectricity.smarElectricity.218347-308": "Floor",
    "smartElectricity.smarElectricity.218347-309": "Please enter floor",
    "smartElectricity.smarElectricity.218347-310": "User Number",
    "smartElectricity.smarElectricity.218347-311": "Please enter user number",
    "smartElectricity.smarElectricity.218347-312": "Owner's Name",
    "smartElectricity.smarElectricity.218347-313": "Please enter the owner's name",
    "smartElectricity.smarElectricity.218347-314": "Please enter full address",
    "smartElectricity.smarElectricity.218347-315": "Device Code",
    "smartElectricity.smarElectricity.218347-316": "Please enter device code",
    "smartElectricity.smarElectricity.218347-317": "Please enter device name",
    "smartElectricity.smarElectricity.218347-318": "Installation time",
    "smartElectricity.smarElectricity.218347-319": "Please select installation time",
    "smartElectricity.smarElectricity.218347-320": "Device Kind",
    "smartElectricity.smarElectricity.218347-321": "Please select the type of device",
    "smartElectricity.smarElectricity.218347-322": "micro-break",
    "smartElectricity.smarElectricity.218347-323": "smoke",
    "smartElectricity.smarElectricity.218347-324": "Qiu",
    "smartElectricity.smarElectricity.218347-325": "Connected Devices",
    "smartElectricity.smarElectricity.218347-326": "Please select a connected device",
    "smartElectricity.smarElectricity.218347-327": "Device Type",
    "smartElectricity.smarElectricity.218347-328": "Please select device type",
    "smartElectricity.smarElectricity.218347-329": "Device Mailing Address",
    "smartElectricity.smarElectricity.218347-330": "Please select the address of the device",
    "smartElectricity.smarElectricity.218347-331": "Micro-break device",
    "smartElectricity.smarElectricity.218347-332": "Please select a device",
    "smartElectricity.smarElectricity.218347-333": "Modify Equipment",
    "smartElectricity.smarElectricity.218347-334": "Contact",
    "smartElectricity.smarElectricity.218347-335": "Please enter a contact",
    "smartElectricity.smarElectricity.218347-336": "Set operation password",
    "smartElectricity.smarElectricity.218347-337": "Please enter password",
    "smartElectricity.smarElectricity.218347-338": "confirm password",
    "smartElectricity.smarElectricity.218347-339": "Please confirm password",
    "smartElectricity.smarElectricity.218347-340": "Change operation password",
    "smartElectricity.smarElectricity.218347-341": "original password",
    "smartElectricity.smarElectricity.218347-341": "Original password",
    "smartElectricity.smarElectricity.218347-342": "New Password",
    "smartElectricity.smarElectricity.218347-343": "Find Device",
    "smartElectricity.smarElectricity.218347-344": "Phone Number",
    "smartElectricity.smarElectricity.218347-345": "Please enter mobile phone number",
    "smartElectricity.smarElectricity.218347-346": "Please enter the device number",
    "smartElectricity.smarElectricity.218347-347": "Alarm message",
    "smartElectricity.smarElectricity.218347-348": "alarm time",
    "smartElectricity.smarElectricity.218347-349": "Alarm Type",
    "smartElectricity.smarElectricity.218347-350": "No alarm",
    "smartElectricity.smarElectricity.218347-351": "processed",
    "smartElectricity.smarElectricity.218347-352": "Please select a date",
    "smartElectricity.smarElectricity.218347-353": "Status",
    "smartElectricity.smarElectricity.218347-354": "Add City",
    "smartElectricity.smarElectricity.218347-355": "province",
    "smartElectricity.smarElectricity.218347-356": "Please select province",
    "smartElectricity.smarElectricity.218347-357": "Please select a city",
    "smartElectricity.smarElectricity.218347-358": "Online Device List",
    "smartElectricity.smarElectricity.218347-359": "Device Address",
    "smartElectricity.smarElectricity.218347-360": "Communication time",
    "smartElectricity.smarElectricity.218347-361": "Device Status",
    "smartElectricity.smarElectricity.218347-362": "List of offline devices",
    "smartElectricity.smarElectricity.218347-363": "Region",
    "smartElectricity.smarElectricity.218347-364": "User Address",
    "smartElectricity.smarElectricity.218347-365": "Registration time",
    "smartElectricity.smarElectricity.218347-366": "username",
    "smartElectricity.smarElectricity.218347-367": "Room Number",
    "smartElectricity.smarElectricity.218347-368": "Edit",
    "smartElectricity.smarElectricity.218347-369": "Alarm Device List",
    "smartElectricity.smarElectricity.218347-370": "Online Status",
    "smartElectricity.smarElectricity.218347-371": "List of settlement applications",
    "smartElectricity.smarElectricity.218347-372": "revoked",
    "smartElectricity.smarElectricity.218347-373": "Settled",
    "smartElectricity.smarElectricity.218347-374": "To be settled",
    "smartElectricity.smarElectricity.218347-375": "Settlement Number",
    "smartElectricity.smarElectricity.218347-376": "Payment Method",
    "smartElectricity.smarElectricity.218347-377": "Card number",
    "smartElectricity.smarElectricity.218347-378": "real name",
    "smartElectricity.smarElectricity.218347-379": "Settlement Amount",
    "smartElectricity.smarElectricity.218347-380": "Platform Commission Fee Percentage",
    "smartElectricity.smarElectricity.218347-381": "Platform Commission Fee",
    "smartElectricity.smarElectricity.218347-382": "Final Settlement Amount",
    "smartElectricity.smarElectricity.218347-383": "Settlement",
    "smartElectricity.smarElectricity.218347-384": "View",
    "smartElectricity.smarElectricity.218347-385": "withdrawn",
    "smartElectricity.smarElectricity.218347-386": "No application list",
    "smartElectricity.smarElectricity.218347-387": "Set platform settlement rates",
    "smartElectricity.smarElectricity.218347-388": "Settlement Rates",
    "smartElectricity.smarElectricity.218347-389": "Please enter rate (%)",
    "smartElectricity.smarElectricity.218347-390": "Save",
    "smartElectricity.smarElectricity.218347-391": "Modify City",
    "smartElectricity.smarElectricity.218347-392": "Add Township",
    "smartElectricity.smarElectricity.218347-393": "Township/Subdistrict Name",
    "smartElectricity.smarElectricity.218347-394": "Please enter township/street name",
    "smartElectricity.smarElectricity.218347-395": "Modify Street",
    "smartElectricity.smarElectricity.218347-396": "Township Name",
    "smartElectricity.smarElectricity.218347-397": "Please enter street name",
    "smartElectricity.smarElectricity.218347-398": "Add Village",
    "smartElectricity.smarElectricity.218347-399": "Village Name",
    "smartElectricity.smarElectricity.218347-401": "Modified Village",
    "smartElectricity.smarElectricity.218347-402": "Modify Region",
    "smartElectricity.smarElectricity.218347-403": "Probe List",
    "smartElectricity.smarElectricity.218347-404": "probe name",
    "smartElectricity.smarElectricity.218347-405": "Current concentration value",
    "smartElectricity.smarElectricity.218347-406": "Alarm status",
    "smartElectricity.smarElectricity.218347-407": "Created on",
    "smartElectricity.smarElectricity.218347-408": "No probe",
    "smartElectricity.smarElectricity.218347-409": "User Authorization List",
    "smartElectricity.smarElectricity.218347-410": "Add License",
    "smartElectricity.smarElectricity.218347-411": "Yihuijia username",
    "smartElectricity.smarElectricity.218347-412": "User login phone number",
    "smartElectricity.smarElectricity.218347-413": "authorization code",
    "smartElectricity.smarElectricity.218347-414": "Authorization Type",
    "smartElectricity.smarElectricity.218347-415": "Authorization Module",
    "smartElectricity.smarElectricity.218347-416": "perpetual license",
    "smartElectricity.smarElectricity.218347-417": "Validity Authorization",
    "smartElectricity.smarElectricity.218347-418": "unauthorized",
    "smartElectricity.smarElectricity.218347-419": "No authorization",
    "smartElectricity.smarElectricity.218347-420": "Clock Settings",
    "smartElectricity.smarElectricity.218347-421": "Set Time",
    "smartElectricity.smarElectricity.218347-422": "Device clock",
    "smartElectricity.smarElectricity.218347-423": "Set clock",
    "smartElectricity.smarElectricity.218347-424": "Read the clock",
    "smartElectricity.smarElectricity.218347-425": "Modify Authorization",
    "smartElectricity.smarElectricity.218347-426": "Please enter the mobile phone number of the user login",
    "smartElectricity.smarElectricity.218347-427": "Please enter authorization type",
    "smartElectricity.smarElectricity.218347-428": "Validity Start Time",
    "smartElectricity.smarElectricity.218347-429": "Please select a validity start time",
    "smartElectricity.smarElectricity.218347-430": "End of validity time",
    "smartElectricity.smarElectricity.218347-431": "Please select the end of the validity period",
    "smartElectricity.smarElectricity.218347-432": "Please select an authorization module",
    "smartElectricity.smarElectricity.218347-433": "Select Module",
    "smartElectricity.smarElectricity.218347-434": "Add",
    "smartElectricity.smarElectricity.218347-435": "No device",
    "smartElectricity.smarElectricity.218347-436": "import",
    "smartElectricity.smarElectricity.218347-437": "Process Settlement",
    "smartElectricity.smarElectricity.218347-438": "Statement Number",
    "smartElectricity.smarElectricity.218347-439": "Please enter rate",
    "smartElectricity.smarElectricity.218347-440": "Payment Type",
    "smartElectricity.smarElectricity.218347-441": "Payment type",
    "smartElectricity.smarElectricity.218347-442": "Order List",
    "smartElectricity.smarElectricity.218347-443": "Order Number",
    "smartElectricity.smarElectricity.218347-444": "Amount Paid",
    "smartElectricity.smarElectricity.218347-445": "Payment time",
    "smartElectricity.smarElectricity.218347-446": "No Order",
    "smartElectricity.smarElectricity.218347-447": "Alarm Information",
    "smartElectricity.smarElectricity.218347-448": "Device alarm",
    "smartElectricity.smarElectricity.218347-449": "The device '{0}' {2} alarm occurs in the {1}, please deal with it in time",
    "smartElectricity.smarElectricity.218347-450": "View Details",
    "smartElectricity.smarElectricity.218347-451": "None",
    "smartElectricity.smarElectricity.218347-452": "City",
    "smartElectricity.smarElectricity.218347-453": "province",
    "smartElectricity.smarElectricity.218347-454": "City",
    "smartElectricity.smarElectricity.218347-455": "District",
    "smartElectricity.smarElectricity.218347-456": "Name of the repairer",
    "smartElectricity.smarElectricity.218347-457": "Maintenance Person's Phone",
    "smartElectricity.smarElectricity.218347-458": "Maintenance Person ID Number",
    "smartElectricity.smarElectricity.218347-459": "Maintenance time",
    "smartElectricity.smarElectricity.218347-460": "Repair Information",
    "smartElectricity.smarElectricity.218347-461": "Picture of the ID card of the repairer",
    "smartElectricity.smarElectricity.218347-462": "OK",
    "smartElectricity.smarElectricity.218347-463": "Not turned on",
    "smartElectricity.smarElectricity.218347-464": "on",
    "smartElectricity.smarElectricity.218347-465": "Door lock equipment",
    "smartElectricity.smarElectricity.218347-466": "Smoke Sensing Devices",
    "smartElectricity.smarElectricity.218347-467": "Gas sensing device",
    "smartElectricity.smarElectricity.218347-468": "Zigbee Device",
    "smartElectricity.smarElectricity.218347-469": "Monitoring Equipment",
    "smartElectricity.smarElectricity.218347-470": "All Modules",
    "smartElectricity.smarElectricity.218347-471": "{0} selected modules",
    "smartElectricity.smarElectricity.218347-472": "Zhejiang Province-Hangzhou",
    "smartElectricity.smarElectricity.218347-473": "Click this function menu to enter the import process",
    "smartElectricity.smarElectricity.218347-474": "Enter mobile phone number",
    "smartElectricity.smarElectricity.218347-475": "Enter the mobile phone number to be imported, click Next to successfully import the registration information, the registration information is in the left menu",
    "smartElectricity.smarElectricity.218347-476": "Please select the device to be imported, click Import after selection",
    "smartElectricity.smarElectricity.218347-477": "Left Menu",
    "smartElectricity.smarElectricity.218347-478": "All the information you import will be automatically generated, and the corresponding content can be viewed in the left menu",
    "smartElectricity.smarElectricity.218347-479": "Docking successful!" ,
    "smartElectricity.smarElectricity.218347-480": "Docking failed!" ,
    "smartElectricity.smarElectricity.218347-481": "All modules selected",
    "smartElectricity.smarElectricity.218347-482": "{0} modules selected",
    "smartElectricity.smarElectricity.218347-483": "Hint",
    "smartElectricity.smarElectricity.218347-484": "Do you want to delete '$'",
    "smartElectricity.smarElectricity.218347-485": "Edit Area Expand",
    "smartElectricity.smarElectricity.218347-486": "Delete returned results",
    "smartElectricity.smarElectricity.218347-487": "Click to modify the village to expand",
    "smartElectricity.smarElectricity.218347-488": "Data parameters before request",
    "smartElectricity.smarElectricity.218347-489": "Click Street",
    
    "smartElectricity.smarElectricity.218347-490": "Parameters when clicking Add",
    "smartElectricity.smarElectricity.218347-491": "User added return parameters",
    "smartElectricity.smarElectricity.218347-492": "Click to modify street to expand",
    "smartElectricity.smarElectricity.218347-493": "Modify parameters before street",
    "smartElectricity.smarElectricity.218347-494": "Building-$",
    "smartElectricity.smarElectricity.218347-495": "Unit-$",
    "smartElectricity.smarElectricity.218347-496": "Lou-$",
    "smartElectricity.smarElectricity.218347-497": "Building {0} - Unit {1} - {2} - Room {3}",
    "smartElectricity.smarElectricity.218347-498": "Delete this user?" ,
    "smartElectricity.smarElectricity.218347-499": "Parameters before deployment",
    "smartElectricity.smarElectricity.218347-500": "Device number cannot be empty",
    "smartElectricity.smarElectricity.218347-501": "Phone number cannot be empty",
    "smartElectricity.smarElectricity.218347-502": "The mobile phone number information is incomplete, please use the one-click import function",
    "smartElectricity.smarElectricity.218347-503": "Device not selected",
    "smartElectricity.smarElectricity.218347-504": "Get navigation bar successful",
    "smartElectricity.smarElectricity.218347-505": "Device Get Button List",
    "smartElectricity.smarElectricity.218347-506": "Request timed out",
    "smartElectricity.smarElectricity.218347-507": "Password cannot be empty",
    "smartElectricity.smarElectricity.218347-508": "The password is not the same twice",
    "smartElectricity.smarElectricity.218347-509": "Password set successfully",
    "smartElectricity.smarElectricity.218347-510": "Original password cannot be empty",
    "smartElectricity.smarElectricity.218347-511": "New password cannot be empty",
    "smartElectricity.smarElectricity.218347-512": "Password changed successfully",
    "smartElectricity.smarElectricity.218347-513": "Operation password",
    "smartElectricity.smarElectricity.218347-514": "Please enter the operation password",
    "smartElectricity.smarElectricity.218347-515": "Your operation is too frequent, please wait a minute...",
    "smartElectricity.smarElectricity.218347-516": "in operation",
    "smartElectricity.smarElectricity.218347-517": "Summoning...",
    "smartElectricity.smarElectricity.218347-518": "In Testing",

    "smartElectricity.smarElectricity.218347-519": "Phase A",
    "smartElectricity.smarElectricity.218347-520": "Phase B",
    "smartElectricity.smarElectricity.218347-521": "Phase C",
    "smartElectricity.smarElectricity.218347-522": "Total Power",
    "smartElectricity.smarElectricity.218347-523": "$",
    "smartElectricity.smarElectricity.218347-524": "Merchant fee interface obtained successfully",
    "smartElectricity.smarElectricity.218347-525": "Add merchant fee template successful",
    "smartElectricity.smarElectricity.218347-526": "Modified parameters",
    "smartElectricity.smarElectricity.218347-527": "Parameters before sending request",
    "smartElectricity.smarElectricity.218347-528": "Modified merchant fee template successful",
    "smartElectricity.smarElectricity.218347-529": "ID when clicking delete",
    "smartElectricity.smarElectricity.218347-530": "Get Uid when clicking delete",
    "smartElectricity.smarElectricity.218347-531": "Delete it?" ,
    "smartElectricity.smarElectricity.218347-532": "Merchant fee template deleted successfully",
    "smartElectricity.smarElectricity.218347-533": "Department number cannot be empty",

    "smartElectricity.smarElectricity.218347-534": "Do you want to delete this department?" ,
    "smartElectricity.smarElectricity.218347-535": "Company number cannot be empty",
    "smartElectricity.smarElectricity.218347-536": "Do you want to delete this company?" ,
    "smartElectricity.smarElectricity.218347-537": "Group number cannot be empty",
    "smartElectricity.smarElectricity.218347-538": "Delete this group?" ,
    "smartElectricity.smarElectricity.218347-539": "Whether the cancellation number is '$'",
    "smartElectricity.smarElectricity.218347-540": "Settlement",
    "smartElectricity.smarElectricity.218347-541": "Settlement rate cannot be empty",
    "smartElectricity.smarElectricity.218347-542": "Please select card number",
    "smartElectricity.smarElectricity.218347-543": "All",
    "smartElectricity.smarElectricity.218347-544": "Do you want to remove this user license?" ,
    "smartElectricity.smarElectricity.218347-545": "Microsoft Yahei",
    "smartElectricity.smarElectricity.218347-546": "error",
    "smartElectricity.smarElectricity.218347-547": "Please select images in jpg, jpeg, png format",
    "smartElectricity.smarElectricity.218347-548": "The maximum size of the image cannot exceed 2M",
    "smartElectricity.smarElectricity.218347-549": "update",
    "smartElectricity.smarElectricity.218347-550": "the upgrade command has been issued",
}



// WEBPACK FOOTER //
// ./src/i18n/lang/En/smartElectricity-en.js